import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { ClientTimesheetResponseStatus } from 'payroll/components/CellRenderers';

const useClientApprovedColumn = () => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback((params) => {
    if (params.node?.group) return null;

    return ClientTimesheetResponseStatus({
      rowData: params.data
    });
  }, []);

  return useMemo(
    () => ({
      field: 'clientApproved',
      headerName: t('clientStatus'),
      sortable: false,
      width: 120,
      initialHide: true,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useClientApprovedColumn;
